var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserSquare = function SvgUserSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.117 18.017c-.734.216-1.6.316-2.617.316h-5c-1.017 0-1.883-.1-2.617-.316.184-2.167 2.409-3.875 5.117-3.875s4.933 1.708 5.117 3.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 1.667h-5c-4.167 0-5.833 1.666-5.833 5.833v5c0 3.15.95 4.875 3.216 5.517.184-2.167 2.409-3.875 5.117-3.875s4.933 1.708 5.117 3.875c2.266-.642 3.216-2.367 3.216-5.517v-5c0-4.167-1.666-5.833-5.833-5.833ZM10 11.808a2.987 2.987 0 0 1-2.983-2.991A2.98 2.98 0 0 1 10 5.833a2.98 2.98 0 0 1 2.983 2.984A2.987 2.987 0 0 1 10 11.808Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.983 8.817A2.987 2.987 0 0 1 10 11.808a2.987 2.987 0 0 1-2.983-2.991A2.98 2.98 0 0 1 10 5.833a2.98 2.98 0 0 1 2.983 2.984Z"
  })));
};
export default SvgUserSquare;